var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.tippy),expression:"tippy"}],class:{
    'h-12 md:h-16 flex justify-center items-center bg-primary-bg text-primary-text hover:opacity-50 tab transition-all duration-200':
      _vm.active,
    'tab h-12  md:h-16 flex justify-center items-center lg:bg-navbar hover:opacity-50 transition-all duration-200':
      !_vm.active
  },attrs:{"content":_vm.label(),"aria-label":_vm.label()},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_c('i',{staticClass:"fal",class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.custom_caption))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }